const calcRate = (total1, total2) => {
    if (!total1 || !total2 || total1 <= 0 || total2 <= 0)
        return 0;
    let result = Number.parseFloat((Math.floor(total1 / total2 * 100 * 100) / 100).toFixed(2));
    return result < 0.01 && result > 0 ? 0.01 : result;
}
export default calcRate;